import { Typography } from 'antd';
import { useCountCallSession, useCountChatSession } from 'hooks';
import React from 'react';
import { formatNumber } from 'utils';

type DashboardAIAgentProps = {};

const DashboardAIAgent: React.FC<DashboardAIAgentProps> = ({}) => {
  const fromDate = new Date(new Date().setHours(0, 0, 0, 0)).toISOString();
  const toDate = new Date(new Date().setHours(23, 59, 59, 999)).toISOString();
  const { data: aiAgentDataCall } = useCountCallSession({
    isHandleByAi: true,
    fromDate,
    toDate
  });

  const { data: aiAgentDataChat } = useCountChatSession({
    isHandleByAi: true,
    fromDate,
    toDate
  });

  return (
    <>
      <div className='mt-4 flex w-full gap-4'>
        <div
          className='flex flex-1 gap-4 rounded-lg border p-4'
          style={{
            boxShadow: '0px 2px 8px #00000029'
          }}
        >
          <div className='flex flex-1 flex-col gap-[14px] border-r'>
            <Typography.Text type='secondary' className='text-sm font-semibold'>
              Đang đàm thoại
            </Typography.Text>
            <Typography.Text className='text-2xl font-semibold'>
              {formatNumber(aiAgentDataCall?.totalCallSessionProcessing || 0)}
            </Typography.Text>
          </div>

          <div className='flex flex-1 flex-col gap-[14px]'>
            <Typography.Text type='secondary' className='text-sm font-semibold'>
              Đang chat
            </Typography.Text>
            <Typography.Text className='text-2xl font-semibold'>
              {formatNumber(aiAgentDataChat?.totalChatSessionProcessing || 0)}
            </Typography.Text>
          </div>
        </div>

        <div className='flex flex-1 gap-4 rounded-lg border p-4'>
          <div className='flex flex-1 flex-col gap-[14px] border-r'>
            <Typography.Text type='secondary' className='text-sm font-semibold'>
              Đã kết thúc gọi
            </Typography.Text>
            <Typography.Text className='text-2xl font-semibold'>
              {formatNumber(aiAgentDataCall?.totalCallSessionCompleted || 0)}
            </Typography.Text>
          </div>

          <div className='flex flex-1 flex-col gap-[14px]'>
            <Typography.Text type='secondary' className='text-sm font-semibold'>
              Đã kết thúc chat
            </Typography.Text>
            <Typography.Text className='text-2xl font-semibold'>
              {formatNumber(aiAgentDataChat?.totalChatSessionCompleted || 0)}
            </Typography.Text>
          </div>
        </div>
      </div>
    </>
  );
};

export default React.memo(DashboardAIAgent);
